import React, { useState } from 'react';
import NewFormHeader from '../../../components/NewFormHeader';
import { Strings } from '../../../utils/strings';
import useStyles from './styles';
import { useFormik, Form, FormikProvider } from 'formik';
import Textbox from '../../../components/Textbox';
import Dropdown from '../../../components/Dropdown';
import {
  announcementVisibleArray,
  getErrorMessage,
} from '../../../utils/appUtils';
import Button from '../../../components/Button';
import { useTheme } from '@mui/material/styles';
import DateSelector from '../../../components/DateSelector';
import TimeSelector from '../../../components/TimeSelector';
import DateTimeContainer from '../../../components/DateTimeContainer';
import { AddAnnouncementSchema } from '../../../utils/validationSchemas';
import moment from 'moment';
import { connect } from 'react-redux';
import { createAnnouncement } from '../../../redux/actions/adminActions/addAnnouncement';
import { useAlert } from 'react-alert';
import MultiSelectDropdown from '../../../components/MultiSelectDropdown';

const NewAnnouncement = (props) => {
  const classes = useStyles();
  const theme = useTheme();
  const alert = useAlert();
  const [annoumncementVisibleList, setAnnouncementVisibleList] = useState(
    announcementVisibleArray()
  );
  const onError = (err) => {
    const error = getErrorMessage(err);
    if (error) {
      alert.error(error);
    }
  };

  const formik = useFormik({
    initialValues: {
      title: '',
      message: '',
      visibleTo: [],
      startDate: '',
      endDate: '',
      startTime: moment(),
      endTime: moment(),
    },
    validationSchema: AddAnnouncementSchema,

    onSubmit: (values) => {
      addAnnouncement(values);
    },
  });

  const addAnnouncement = (values) => {
    let startDateTime = moment(
      moment(values.startDate).format('YYYY-MM-DD') +
        ' ' +
        moment(values.startTime).format('HH:mm')
    ).format();
    let endDateTime = moment(
      moment(values.endDate).format('YYYY-MM-DD') +
        ' ' +
        moment(values.endTime).format('HH:mm')
    ).format();
    const data = {
      title: values.title,
      message: values.message,
      visibleTo: values.visibleTo.map((item) => item.value),
      startDate: startDateTime,
      endDate: endDateTime,
    };
    props.createAnnouncement(data, (err) => onError(err), props.onNewClose);
  };

  const { errors, touched, values, handleSubmit, handleChange, setFieldValue } =
    formik;

  return (
    <>
      <div className={classes.dialog_mask} />
      <div className={classes.dialog_container}>
        <NewFormHeader
          title={Strings.NEW_ANNOUNCEMENT}
          onNewClose={props.onNewClose}
        />
        <FormikProvider value={formik}>
          <Form autoComplete='off' noValidate onSubmit={handleSubmit}>
            <div className={classes.form_details}>
              <Textbox
                name='title'
                onChange={handleChange('title')}
                value={values.title}
                label={Strings.TITLE}
                error={Boolean(touched.title && errors.title)}
                helperText={touched.title && errors.title}
                placeholder={Strings.ENTER_TITLE}
                labelClassName={classes.form_label}
                className={classes.form_input}
              />
              <Textbox
                name='message'
                onChange={handleChange('message')}
                value={values.message}
                label={Strings.MESSAGE}
                error={Boolean(touched.message && errors.message)}
                helperText={touched.message && errors.message}
                placeholder={Strings.TYPE_HERE}
                labelClassName={classes.form_label}
                className={classes.form_input}
                containerClassName={classes.form_input_container}
                multiline
                rows={5}
              />
              <MultiSelectDropdown
                name='visibleTo'
                onChange={(value) => setFieldValue('visibleTo', value)}
                value={values.visibleTo}
                label={Strings.VISIBLE_TO}
                error={Boolean(touched.visibleTo && errors.visibleTo)}
                helperText={touched.visibleTo && errors.visibleTo}
                title={Strings.SELECT_AN_OPTION}
                labelClassName={classes.form_label}
                className={classes.form_input}
                containerClassName={classes.form_input_container}
                optionArray={annoumncementVisibleList}
                hideAvatar={true}
              />
              <DateTimeContainer
                label={Strings.START_DATE_TIME}
                containerClassName={classes.form_input_container}
              >
                <DateSelector
                  name='startDate'
                  onChange={(value) => setFieldValue('startDate', value)}
                  value={values.startDate}
                  error={Boolean(touched.startDate && errors.startDate)}
                  helperText={touched.startDate && errors.startDate}
                  format='MMM dd, yyyy'
                  placeholder={Strings.SAMPLE_DATE}
                  containerClassName={classes.date_selector_container}
                  minDate={new Date()}
                />
                <TimeSelector
                  name='startTime'
                  onChange={(value) =>
                    setFieldValue(
                      'startTime',
                      value ? moment(value, 'HH:mm') : ''
                    )
                  }
                  value={values.startTime}
                  error={Boolean(touched.startTime && errors.startTime)}
                  helperText={touched.startTime && errors.startTime}
                  placeholder={Strings.SAMPLE_TIME}
                />
              </DateTimeContainer>
              <DateTimeContainer
                label={Strings.END_DATE_TIME}
                containerClassName={classes.form_input_container}
              >
                <DateSelector
                  name='endDate'
                  onChange={(value) => setFieldValue('endDate', value)}
                  value={values.endDate}
                  error={Boolean(touched.endDate && errors.endDate)}
                  helperText={touched.endDate && errors.endDate}
                  format='MMM dd, yyyy'
                  placeholder={Strings.SAMPLE_DATE}
                  containerClassName={classes.date_selector_container}
                  minDate={new Date()}
                />
                <TimeSelector
                  name='endTime'
                  onChange={(value) =>
                    setFieldValue(
                      'endTime',
                      value ? moment(value, 'HH:mm') : ''
                    )
                  }
                  value={values.endTime}
                  error={Boolean(touched.endTime && errors.endTime)}
                  helperText={touched.endTime && errors.endTime}
                  placeholder={Strings.SAMPLE_TIME}
                />
              </DateTimeContainer>
              <Button
                type='submit'
                text={Strings.ADD_NEW_ANNOUNCEMENT}
                loading={props.annAnnouncementLoading}
                disabled={props.annAnnouncementLoading}
                containerClassName={classes.add_button_container}
                className={classes.add_button}
                loaderColor={theme.palette.background_button_text}
              />
            </div>
          </Form>
        </FormikProvider>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  addAnnouncementData: state.addAnnouncementData.data,
  annAnnouncementLoading: state.addAnnouncementData.loading,
});

export default connect(mapStateToProps, {
  createAnnouncement,
})(NewAnnouncement);
